module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_12-cac990bf2499fac15f7e12ee09c72bf3.png";